/**
 * Views Module
 * Imported in app_* level
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PermissionShowDirective } from "./permissionShow.directive";
import { PermissionIfDirective } from "./permissionIf.directive";
import { PermissionComponent } from "./permission.component";


@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        PermissionShowDirective,
        PermissionIfDirective,
        PermissionComponent,
    ],
    exports: [
        PermissionShowDirective,
        PermissionIfDirective,
        PermissionComponent,
    ]
})
export class PermissionModule {
}
